<template>
	<div
		:style="{ alignItems }"
		:class="$style['data-row']"
	>
		<slot />
	</div>
</template>

<script>
export default {
	name: 'DataRow',
	props: {
		alignItems: {
			type: String,
			default: 'flex-end'
		}
	}
}
</script>

<style lang="scss" module>
.data-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: $gutter * 2;
    gap: $gutter * 2;

    &:last-child {
        margin-bottom: 0;
    }
}
</style>
